import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";

const ActionBar = ({
  handleApplyFilter,
  handleRemoveFilter,
  disableApplyFilter = false,
}: {
  handleApplyFilter: () => void;
  handleRemoveFilter: () => void;
  disableApplyFilter?: boolean;
}) => {
  const { l10n } = useLocalization();

  return (
    <div className="padding--all--s">
      <Row>
        <Row.Item>
          <Button
            kind="plain"
            label={l10n.getString("label-remove-filter")}
            testId="remove-filters-button"
            size="s"
            onClick={handleRemoveFilter}
          />
        </Row.Item>
        <Row.Item shrink>
          <Button
            label={l10n.getString("label-apply")}
            testId="apply-filters-button"
            size="s"
            onClick={handleApplyFilter}
            disabled={disableApplyFilter}
          />
        </Row.Item>
      </Row>
    </div>
  );
};

export default ActionBar;
